import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "accordion" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { style: {"padding":"10px"} }
const _hoisted_4 = { style: {"display":"flex","justify-content":"flex-end","gap":"8px","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridItem = _resolveComponent("DxGridItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxAccordion = _resolveComponent("DxAccordion")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DxAccordion, {
        "data-source": _ctx.accordionData,
        "item-title-template": "itemTitle",
        onSelectionChanged: _ctx.onAccordionSelectionChanged
      }, {
        itemTitle: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("b", null, _toDisplayString(data.title), 1)
          ])
        ]),
        item: _withCtx(({ data }) => [
          (data.title === 'Utilizatori')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 0,
                "data-source": _ctx.dsUtilizatori,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedUtilizatori,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxToolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxGridItem, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxButton, {
                            icon: "add",
                            type: "success",
                            onClick: _ctx.showAddUserPopup
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Username",
                    allowEditing: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true),
          (data.title === 'Agenti')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 1,
                "data-source": _ctx.dsAgenti,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedAgenti,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxColumn, { "data-field": "Cod" }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Citeste",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Modifica",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Sterge",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true),
          (data.title === 'Tipuri de Documente')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 2,
                "data-source": _ctx.dsTipuri,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedDocumente,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "UserID",
                    visible: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Cod",
                    visible: false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "CategorieID",
                    caption: "Categorie"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxLookup, {
                        "data-source": _ctx.dsCategorii,
                        "value-expr": "Id",
                        "display-expr": "Nume"
                      }, null, 8, ["data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxColumn, { "data-field": "Nume" }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Citeste",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Modifica",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Sterge",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true),
          (data.title === 'Gestiuni')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 3,
                "data-source": _ctx.dsGestiuni,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedGestiuni,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxColumn, { "data-field": "Cod" }),
                  _createVNode(_component_DxColumn, { "data-field": "Nume" }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Citeste",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Modifica",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Sterge",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true),
          (data.isModule)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "module-section-label" }, "Meniuri", -1)),
                _createVNode(_component_DxDataGrid, {
                  "data-source": _ctx.getModuleMeniuri(data.modulId),
                  "key-expr": "ID",
                  allowColumnReordering: true,
                  allowColumnResizing: true,
                  columnAutoWidth: false,
                  columnMinWidth: 50,
                  columnResizingMode: 'nextColumn',
                  "show-borders": true,
                  "filter-sync-enabled": true,
                  "show-row-lines": true,
                  "show-column-lines": false,
                  class: "border",
                  "on-row-updated": (e) => _ctx.onRowUpdatedModuleMeniu(e),
                  "on-editor-preparing": _ctx.onEditor
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxEditing, {
                      mode: "cell",
                      "allow-updating": true
                    }),
                    _createVNode(_component_DxPaging, {
                      "page-size": 10,
                      "page-index": 1
                    }),
                    _createVNode(_component_DxLoadPanel, {
                      enabled: true,
                      "indicator-src": 'reload6.gif'
                    }),
                    _createVNode(_component_DxFilterRow, { visible: true }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Nume",
                      allowEditing: false,
                      "allow-filtering": true
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Explicatie",
                      allowEditing: false,
                      "allow-filtering": true
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "HasRight",
                      "data-type": "boolean",
                      caption: "Are drept?",
                      allowEditing: true,
                      "allow-filtering": false
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Citeste",
                      "data-type": "boolean",
                      allowEditing: true,
                      "allow-filtering": false
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Modifica",
                      "data-type": "boolean",
                      allowEditing: true,
                      "allow-filtering": false
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Sterge",
                      "data-type": "boolean",
                      allowEditing: true,
                      "allow-filtering": false
                    })
                  ]),
                  _: 1
                }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]),
                _cache[2] || (_cache[2] = _createElementVNode("div", {
                  class: "module-section-label",
                  style: {"margin-top":"14px"}
                }, "Drepturi Custom", -1)),
                _createVNode(_component_DxDataGrid, {
                  "data-source": _ctx.getModuleDrepturi(data.modulId),
                  "key-expr": "ID",
                  allowColumnReordering: true,
                  allowColumnResizing: true,
                  columnAutoWidth: false,
                  columnMinWidth: 50,
                  columnResizingMode: 'nextColumn',
                  "show-borders": true,
                  "filter-sync-enabled": true,
                  "show-row-lines": true,
                  "show-column-lines": false,
                  class: "border",
                  "on-row-updated": (e) => _ctx.onRowUpdatedModuleCustom(e),
                  "on-editor-preparing": _ctx.onEditor
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxEditing, {
                      mode: "cell",
                      "allow-updating": true
                    }),
                    _createVNode(_component_DxPaging, {
                      "page-size": 10,
                      "page-index": 1
                    }),
                    _createVNode(_component_DxLoadPanel, {
                      enabled: true,
                      "indicator-src": 'reload6.gif'
                    }),
                    _createVNode(_component_DxFilterRow, { visible: true }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Nume",
                      allowEditing: false,
                      "allow-filtering": true
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Explicatie",
                      allowEditing: false,
                      "allow-filtering": true
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "HasRight",
                      "data-type": "boolean",
                      caption: "Are drept?",
                      allowEditing: true,
                      "allow-filtering": false
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Citeste",
                      "data-type": "boolean",
                      allowEditing: true,
                      "allow-filtering": false
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Modifica",
                      "data-type": "boolean",
                      allowEditing: true,
                      "allow-filtering": false
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "Sterge",
                      "data-type": "boolean",
                      allowEditing: true,
                      "allow-filtering": false
                    })
                  ]),
                  _: 1
                }, 8, ["data-source", "on-row-updated", "on-editor-preparing"])
              ], 64))
            : _createCommentVNode("", true),
          (data.title === 'Categorii Comenzi')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 5,
                "data-source": _ctx.dsCategoriiComenzi,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedCategoriiComenzi,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Nume",
                    "allow-filtering": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Citeste",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Modifica",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Sterge",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true),
          (data.title === 'Categorii Produse')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 6,
                "data-source": _ctx.dsCategoriiProduse,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedCategoriiProduse,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "ClasaID",
                    "allow-filtering": true,
                    caption: "Clasa"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxLookup, {
                        "data-source": _ctx.dsClase,
                        "value-expr": "ID",
                        "display-expr": "Nume"
                      }, null, 8, ["data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Nume",
                    "allow-filtering": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Citeste",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Modifica",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Sterge",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true),
          (data.title === 'Capitole')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 7,
                "data-source": _ctx.dsCapitole,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedCapitole,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Nume",
                    "allow-filtering": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Citeste",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Modifica",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Sterge",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true),
          (data.title === 'Categorii Documente')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 8,
                "data-source": _ctx.dsCategoriiDocumente,
                "key-expr": "ID",
                allowColumnReordering: true,
                allowColumnResizing: true,
                columnAutoWidth: false,
                columnMinWidth: 50,
                columnResizingMode: 'nextColumn',
                "show-borders": true,
                "filter-sync-enabled": true,
                "show-row-lines": true,
                "show-column-lines": false,
                class: "border",
                "on-row-updated": _ctx.onRowUpdatedCategoriiDocumente,
                "on-editor-preparing": _ctx.onEditor,
                ref: "dataGridRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxEditing, {
                    mode: "cell",
                    "allow-updating": true
                  }),
                  _createVNode(_component_DxPaging, {
                    "page-size": 10,
                    "page-index": 1
                  }),
                  _createVNode(_component_DxLoadPanel, {
                    enabled: true,
                    "indicator-src": 'reload6.gif'
                  }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Nume",
                    "allow-filtering": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "HasRight",
                    "data-type": "boolean",
                    caption: "Are drept?",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Citeste",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Modifica",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Sterge",
                    "data-type": "boolean",
                    allowEditing: true,
                    "allow-filtering": false
                  })
                ]),
                _: 1
              }, 8, ["data-source", "on-row-updated", "on-editor-preparing"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source", "onSelectionChanged"])
    ]),
    _createVNode(_component_DxPopupAdd, { visible: _ctx.isModalVisible }, null, 8, ["visible"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isPopupUtilizatoriVisible,
      title: "Adăugare Utilizator în Rol",
      width: 450,
      height: 250
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_select, {
            modelValue: _ctx.selectedUserId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUserId) = $event)),
            items: _ctx.dsUtilizatoriNeasignati,
            "item-title": "Username",
            "item-value": "ID",
            variant: "outlined",
            placeholder: "Selectați utilizatorul...",
            label: "Utilizator"
          }, null, 8, ["modelValue", "items"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "100",
              onClick: _ctx.onSaveUtilizatorPopup
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              width: "100",
              onClick: _ctx.onCancelUtilizatorPopup
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}